import { render, staticRenderFns } from "./ReportOrder.vue?vue&type=template&id=4ce70f65&scoped=true"
import script from "./ReportOrder.vue?vue&type=script&lang=js"
export * from "./ReportOrder.vue?vue&type=script&lang=js"
import style0 from "./ReportOrder.vue?vue&type=style&index=0&id=4ce70f65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce70f65",
  null
  
)

export default component.exports